import { render } from "./ProtectInstance.vue?vue&type=template&id=3e1d2a4f"
import script from "./ProtectInstance.vue?vue&type=script&lang=js"
export * from "./ProtectInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__